import React, { useState, useEffect, useCallback } from 'react';
import { useInformativos } from '../../../context/InformativosContext';
import api from '../../../services/api';
import './InformativosSidebar.css';

export default function InformativosSidebar() {
  const [unviewedInformativos, setUnviewedInformativos] = useState([]);
  const [loading, setLoading] = useState(false);
  const { lastUpdate } = useInformativos();

  const fetchUnviewedInformativos = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/informativos/unviewed');
      setUnviewedInformativos(res.data.informativos);
    } catch (err) {
      console.error('Erro ao buscar informativos não vistos:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUnviewedInformativos();
  }, [fetchUnviewedInformativos, lastUpdate]);

  const handleViewInformativo = informativo => {
    const element = document.getElementById(`informativo-card-${informativo.id}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      element.classList.add('pulse-animation');
      setTimeout(() => element.classList.remove('pulse-animation'), 1500);
    }
  };

  /**
   * RESOLUÇÃO DO ERRO no-nested-ternary
   * Substituímos ternários aninhados por lógica procedural limpa.
   */
  const renderThumbnail = informativo => {
    // 1. Caso base: não há imagens
    if (!informativo.images || informativo.images.length === 0) {
      return null;
    }

    const apiBase = process.env.REACT_APP_URL_BASE || '';
    const apiOrigin = apiBase.replace(/\/api\/?$/i, '').replace(/\/$/, '');
    const firstImage = informativo.images[0];
    const imageSrc = `${apiOrigin}/uploads/${firstImage}`;
    const isPdf = firstImage.toLowerCase().endsWith('.pdf');

    // 2. Retorno para PDF
    if (isPdf) {
      return (
        <div className="item-thumbnail">
          <div className="pdf-icon-mini">📄</div>
        </div>
      );
    }

    // 3. Retorno para Imagem (Padrão)
    return (
      <div className="item-thumbnail">
        <img src={imageSrc} alt={informativo.title} className="thumbnail-image" />
      </div>
    );
  };

  return (
    <div className="informativos-sidebar-overlay open">
      <div className="informativos-sidebar" onClick={e => e.stopPropagation()}>
        <div className="sidebar-header">
          <h3>Informativos Pendentes</h3>
        </div>

        <div className="sidebar-content">
          {/* Lógica de renderização principal sem ternários complexos */}
          {loading && (
            <div className="loading-state">
              <div className="loading-spinner"></div>
              <p>Carregando...</p>
            </div>
          )}

          {!loading && unviewedInformativos.length === 0 && (
            <div className="empty-state">
              <div className="empty-icon">✅</div>
              <h4>Todos os informativos foram vistos!</h4>
              <p>Você está em dia com todas as novidades.</p>
            </div>
          )}

          {!loading && unviewedInformativos.length > 0 && (
            <div className="informativos-list">
              {unviewedInformativos.map(informativo => (
                <div
                  key={informativo.id}
                  className="informativo-item"
                  onClick={() => handleViewInformativo(informativo)}
                >
                  {renderThumbnail(informativo)}

                  <div className="item-content">
                    <h4 className="item-title">{informativo.title}</h4>
                    <p className="item-description">
                      {informativo.description?.substring(0, 80)}
                      {informativo.description?.length > 80 && '...'}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
